export default () => {

  const $topicsColumnsLink = $('.topics-columns-item-link, .topics-columns-item-img');

  if ($topicsColumnsLink.length) {

    $topicsColumnsLink.on({
      mouseenter: (e) => {
        $(e.currentTarget).parents('.topics-columns-item').addClass('-hovered');
      },
      mouseleave: (e) => {
        $(e.currentTarget).parents('.topics-columns-item').removeClass('-hovered');
      }
    });

  }

};
